// The Developer section's routes (SBX D9). API keys and Documentation moved here from Settings; their
// old routes redirect (App.js), so bookmarks and links in old e-mails keep working.

export const DEVELOPER_BASE = '/developer';

export const DEVELOPER_PATHS = {
    overview: `${DEVELOPER_BASE}/overview`,
    integrations: `${DEVELOPER_BASE}/integrations`,
    requests: `${DEVELOPER_BASE}/requests`,
    outbox: `${DEVELOPER_BASE}/outbox`,
    webhooks: `${DEVELOPER_BASE}/webhooks`,
    vendorCalls: `${DEVELOPER_BASE}/vendor-calls`,
    metrics: `${DEVELOPER_BASE}/metrics`,
    activity: `${DEVELOPER_BASE}/activity`,
    apiKeys: `${DEVELOPER_BASE}/api-keys`,
    documentation: `${DEVELOPER_BASE}/docs`,
};

/** The existing Import run list (not moved: it stays under Settings -> Import). */
export const IMPORTS_PATH = '/import/run/status';
export const importRunPath = (runId: string) => `/import/run/list/${runId}`;

export const LEGACY_REDIRECTS: Array<[string, string]> = [
    ['/import/api-keys', DEVELOPER_PATHS.apiKeys],
    ['/import/docs', DEVELOPER_PATHS.documentation],
    // DSEC D2: the Developer notifications became the Activity (links in old e-mails).
    [`${DEVELOPER_BASE}/notifications`, DEVELOPER_PATHS.activity],
    // DSEC INT: Settings › Integrations (the per-vendor set-up help) became Developer › Integrations.
    ['/import/integrations', DEVELOPER_PATHS.integrations],
];

const PAGE_PATHS: Record<string, string> = {
    overview: DEVELOPER_PATHS.overview,
    integrations: DEVELOPER_PATHS.integrations,
    api_keys: DEVELOPER_PATHS.apiKeys,
    documentation: DEVELOPER_PATHS.documentation,
    request_log: DEVELOPER_PATHS.requests,
    imports: IMPORTS_PATH,
    outbox: DEVELOPER_PATHS.outbox,
    webhook_deliveries: DEVELOPER_PATHS.webhooks,
    vendor_calls: DEVELOPER_PATHS.vendorCalls,
    metrics: DEVELOPER_PATHS.metrics,
    activity: DEVELOPER_PATHS.activity,
};

export const pagePath = (page: string) => PAGE_PATHS[page] || DEVELOPER_PATHS.overview;
